import { Link } from "@tanstack/react-router";

function RouteNotFound() {
  return (
    <>
      <div>
        <p>404 Not Found</p>
        <Link to="/">Home</Link>
      </div>
    </>
  );
}

export { RouteNotFound };
